export function confidenceColor(confidence) {
  if (confidence === 'high') return 'green';
  if (confidence === 'medium') return 'gold';
  if (confidence === 'low') return 'red';
  return 'blue';
}

export function citationBadge(citation) {
  if (citation.authority === 'official_cms') {
    return { color: 'green', label: 'Official CMS' };
  }
  if (citation.evidence_type === 'webinar_clarification') {
    return { color: 'blue', label: 'Webinar clarification' };
  }
  return { color: 'default', label: 'Source' };
}

export function screeningStatusColor(status) {
  if (status === 'likely_bridge_candidate') return 'green';
  if (status === 'likely_part_d_route') return 'blue';
  if (status === 'unlikely_bridge_candidate') return 'red';
  if (status === 'needs_more_information') return 'gold';
  return 'default';
}

export function reasonStatusColor(status) {
  if (status === 'met') return 'green';
  if (status === 'not_met') return 'red';
  if (status === 'part_d_route') return 'blue';
  if (status === 'workflow_note') return 'purple';
  return 'gold';
}
